import { FunctionComponent } from 'preact';
import { useState } from 'preact/hooks';
import { usePopper } from 'react-popper';
import Currency from '../common/Currency';

const FreeDelivery: FunctionComponent<FreeDeliveryProps> = ({ amountUntilFreeDelivery }) => {
    const [ referenceElem, setReferenceElem ] = useState<HTMLButtonElement|null>(null);
    const [ popperElem, setPopperElem ] = useState<HTMLSpanElement|null>(null);
    const [ arrowElem, setArrowElem ] = useState<HTMLDivElement|null>(null);
    const { styles, attributes, update } = usePopper(referenceElem, popperElem, {
        placement: 'top',
        modifiers: [
            { name: 'arrow', options: { element: arrowElem }},
            { name: 'offset', options: { offset: [ 0, 8 ] }},
        ],
    });

    const onEnter = () => {
        popperElem?.setAttribute('data-show', '');
        if (update !== null) {
            update();
        }
    };

    const onLeave = () => {
        popperElem?.removeAttribute('data-show');
        if (update !== null) {
            update();
        }
    };

    return <>
        <div className="header__basket-summary_free-delivery">
            <button
                ref={setReferenceElem}
                type="button"
                className="header__basket-summary_free-delivery-icon"
                onMouseEnter={onEnter}
                onMouseLeave={onLeave}
                onFocus={onEnter}
                onBlur={onLeave}
            />
            <span className="d-inline d-sm-none d-lg-inline">
                {(parseFloat(amountUntilFreeDelivery) > 0) ?
                    <>Add <b><Currency amount={amountUntilFreeDelivery}/></b> for Free Delivery</> :
                    <>Free Delivery ✅</>
                }
            </span>
        </div>

        <div className="d-none d-sm-block d-lg-none">
            <span ref={setPopperElem} className="js-tooltip" id="js-header__basket-summary_free-delivery" role="tooltip" style={styles.popper} {...attributes.popper}>
                {(parseFloat(amountUntilFreeDelivery) > 0) ?
                    <>Add <b><Currency amount={amountUntilFreeDelivery}/></b> for Free Delivery</> :
                    <>Free Delivery ✅</>
                }
                <div ref={setArrowElem} style={styles.arrow} className="js-arrow"></div>
            </span>
        </div>
    </>;
};

interface FreeDeliveryProps {
    amountUntilFreeDelivery: string;
}

export default FreeDelivery;
